
import * as React from 'react';
import { injectInitialProps } from '../../utilities/components/Props';
import { withSelectedItems } from '../decorators/selectors';
import { Fragment } from '../../utilities/components/Fragment';

/**
 * @public
 */
export const enum SelectionVisibilityMode {
  hideWithSelection = 'hideWithSelection',
  showOnlyWithSelection = 'showOnlyOnSelection'
}

/**
 * Component which conditionally renders its children based on the presence or not
 * of selected items in the currents Items Scope.
 * @public
 */
export const SelectionVisibility = withSelectedItems()(class extends React.PureComponent<{
  itemKeys: string[];
  visibilityMode: SelectionVisibilityMode;
}> {
  public render(): JSX.Element | null {
    const hasSelection = this.props.itemKeys.length > 0;

    return (this.props.visibilityMode === SelectionVisibilityMode.showOnlyWithSelection ? hasSelection : !hasSelection) ?
      (
        <Fragment>{ this.props.children }</Fragment>
      ) :
      null;
  }
});

/**
 * @public
 */
export const ShowOnlyWithSelection = injectInitialProps(() => ({
  visibilityMode: SelectionVisibilityMode.showOnlyWithSelection
}))(SelectionVisibility);

/**
 * @public
 */
export const HideWithSelection = injectInitialProps(() => ({
  visibilityMode: SelectionVisibilityMode.hideWithSelection
}))(SelectionVisibility);
